module.exports = __webpack_public_path__ + "img/hyperx-alloy-elite-2-preview.0c615a87.png";